import { DropdownTitleLayout, RecipientsDropdown } from "./components/RecipientsDropdown";
import { LetterEventName, logLetterEvent } from "./helpers/logLetterEvent";
import { useCallback, useMemo, useState } from "react";

import { Button } from "react-migration/components/DeprecatedButton";
import Feature from "src/js/stores/user/Feature";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { LetterPreview } from "./components/LetterPreview";
import { LetterStep } from "src/js/stores/letter/store";
import hasFeature from "src/js/stores/user/actions/hasFeature";
import { updateCurrentStep } from "src/js/stores/letter/actions";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export const LetterPreviewStep = () => {
  const { t } = useTranslation();
  const [isNextBlocked, setIsNextBlocked] = useState(false);

  const isPhysicalSendAvailable = hasFeature(Feature.physicalSend);

  const onBackClick = () => {
    updateCurrentStep(LetterStep.TemplateEditor);
    logLetterEvent({
      name: LetterEventName.LETTERS_FORM_PREVIEW_STEP_BACK_BUTTON_CLICKED,
    });
  };
  const onNextClick = useCallback(() => {
    if (!isPhysicalSendAvailable) {
      updateCurrentStep(LetterStep.FinishAndDownload);
      logLetterEvent({
        name: LetterEventName.LETTERS_FORM_PREVIEW_STEP_FINISH_CLICKED,
      });
    } else {
      updateCurrentStep(LetterStep.ConfirmAndSend);
      logLetterEvent({
        name: LetterEventName.LETTERS_FORM_PREVIEW_STEP_CONFIRM_AND_SEND_CLICKED,
      });
    }
  }, [isPhysicalSendAvailable]);

  const percentage = useMemo(() => (isPhysicalSendAvailable ? 50 : 66), [isPhysicalSendAvailable]);

  return (
    <div data-testid="letters-template-preview-step" className="flex flex-col w-full h-full">
      <Header />
      <RecipientsDropdown titleLayout={DropdownTitleLayout.HORIZONTAL} />
      <div
        data-testid="letter-preview-wrapper"
        className="flex justify-center w-full m-auto overflow-hidden grow bg-background-surface-neutral"
      >
        <LetterPreview showValues onBlockNext={setIsNextBlocked} />
      </div>
      <Footer percentage={percentage}>
        <div className="flex justify-between grow">
          <Button.Secondary onClick={onBackClick}>{t("sites.letters.back")}</Button.Secondary>
          <Button.Primary disabled={isNextBlocked} form="recipientsForm" onClick={onNextClick}>
            {isPhysicalSendAvailable
              ? t("sites.letters.next_confirm_and_send_button")
              : t("sites.letters.finish_and_download")}
          </Button.Primary>
        </div>
      </Footer>
    </div>
  );
};
